import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const steps = [
  {
    id: "0",
    name: capitalize(i18n.t("template.type")),
  },
  {
    id: "1",
    name: capitalize(i18n.t("variables")),
  },
  {
    id: "2",
    name: capitalize(i18n.t("tags")),
  },
  {
    id: "3",
    name: capitalize(i18n.t("printing")),
  },
];
